import { failure, inProgress, notAsked, RemoteData, success } from 'ngx-remotedata';
import { ErrorWrapper } from '../models/common';
import { CustomTemplate, CustomTemplateUpdate } from './model';
import { CustomTemplatesActions, CustomTemplatesActionTypes } from './actions';

export type CustomTemplatesState = RemoteData<CustomTemplate[], ErrorWrapper>;

export function customTemplatesReducer(
    state: CustomTemplatesState = notAsked(),
    action: CustomTemplatesActions
): CustomTemplatesState {
    switch (action.type) {
        case CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATES:
            return inProgress([] as CustomTemplate[]);
        case CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATES_SUCCESS:
            return success(action.payload);
        case CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATES_FAILURE:
            return failure(action.payload);
        default:
            return state;
    }
}

export type CustomTemplateState = RemoteData<CustomTemplate | CustomTemplateUpdate, ErrorWrapper>;

export function customTemplateReducer(
    state: CustomTemplateState = notAsked(),
    action: CustomTemplatesActions
): CustomTemplateState {
    switch (action.type) {
        // Load
        case CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATE:
            return inProgress({} as CustomTemplate);
        case CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATE_SUCCESS:
            return success(action.payload);
        case CustomTemplatesActionTypes.LOAD_CUSTOM_TEMPLATE_FAILURE:
            return failure(action.payload);

        // Create
        case CustomTemplatesActionTypes.CREATE_CUSTOM_TEMPLATE:
            return inProgress({} as CustomTemplate);
        case CustomTemplatesActionTypes.CREATE_CUSTOM_TEMPLATE_SUCCESS:
            return success(action.payload);
        case CustomTemplatesActionTypes.CREATE_CUSTOM_TEMPLATE_FAILURE:
            return failure(action.payload);

        // Update
        case CustomTemplatesActionTypes.UPDATE_CUSTOM_TEMPLATE:
            return inProgress({} as CustomTemplate);
        case CustomTemplatesActionTypes.UPDATE_CUSTOM_TEMPLATE_SUCCESS:
            return success({ ...state, ...action.payload });
        case CustomTemplatesActionTypes.UPDATE_CUSTOM_TEMPLATE_FAILURE:
            return failure(action.payload);

        // Delete
        case CustomTemplatesActionTypes.DELETE_CUSTOM_TEMPLATE:
            return inProgress({} as CustomTemplate);
        case CustomTemplatesActionTypes.DELETE_CUSTOM_TEMPLATE_SUCCESS:
            return success({} as CustomTemplate);
        case CustomTemplatesActionTypes.DELETE_CUSTOM_TEMPLATE_FAILURE:
            return failure(action.payload);

        default:
            return state;
    }
}
